var UitkRatingIconMap = [
    ['star', 'star'],
    ['alternate', 'brightness_1']
];
var UitkRatingIcons = new Map(UitkRatingIconMap);

export { UitkRatingIcons };
